var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responses"},[(_vm.list)?_c('List',{attrs:{"DB":_vm.list},on:{"emit":_vm.emit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }